import React from 'react'
import '../styles/style.css'
import about from '../images/about.svg'
import unsubscribe from '../images/unsubscribe.svg'
import short from '../images/short.svg'
import faq from '../images/faq.svg'
import $ from 'jquery'
import {withRouter} from 'react-router-dom'
import { FRONT_END_NAME } from './constants'

class Menu extends React.Component {

    constructor(props){
        super(props);
        this.wrapperRef=React.createRef();
    }

    setWrapperRef =(node)=> {
        console.log("ref",node);
      this.wrapperRef = node;
      
    }

    componentDidMount (){
        //this.getExercisesList();
        console.log("inside menu");
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (e)=> {
        //debugger;
        
        if (e.target.id != 'menuInner' && !$('#menuInner').find(e.target).length) {
            this.hideMenu();
            $("#addToHomeScreen").hide();
        }
      }
  
    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
    
    hideMenu = () =>{
        //this.setState({showMenu:true});
        $("#menuComp").hide();
    }

    openCreateShortcut = () =>{
        $("#addToHomeScreen").show();
        this.hideMenu();
    }

    render() {

        return (
            <>
            <div className="modal" id="addToHomeScreen">
                <div className="modal-content">
                    <div className="modal-heading">                      
                        <p className={"popup-b"}>
                           Add To Home Screen
                        </p>
                    </div>
                    <div className="apply-modal-header">
                        <p>
                            <ol style={{marginLeft:"15px"}}>
                                <li>Open browser settings menu.</li>
                                <li>Tap on add to home screen.</li>
                            </ol>
                            
                        </p>
                    </div>
                </div>
            </div>

            <div className="modal-menu" id="menuComp">
                <div className="modal-content-menu" id="menuInner">
                    <div className="menu-item">
                        <a onClick={()=>{this.props.history.push(FRONT_END_NAME+"/about")}}>
                            <span><img src={about}></img></span>
                            <span>About Service</span>
                        </a>
                    </div>
                    {/* <div className="menu-item" >
                        <a  onClick={this.openCreateShortcut}>
                            <span><img src={short}></img></span>
                            <span>Create Shortcut</span>
                        </a>
                    </div> */}
                    <div className="menu-item">
                        <a href="#" onClick={() => {this.hideMenu();this.props.showUnsubscribeUser()}}>
                            <span><img src={unsubscribe}></img></span>
                            <span>Unsubscribe</span>
                        </a>
                    </div>
                    <div className="menu-item" onClick={()=>{this.props.history.push(FRONT_END_NAME+"/faq")}}>
                        <a>
                            <span><img src={faq}></img></span>
                            <span>FAQs</span>
                        </a>
                    </div>
                </div>
            </div></>
        );
    }
}

export default withRouter(Menu);